<section>
  <p-scrollTop />
  <div class="mb-4 flex gap-2 md:justify-between">
    <div class="basis-full lg:basis-1/4 md:basis-1/2 p-0">
      <p-select styleClass="w-full" [formControl]="selectedRabbit" placeholder="Kaninchen" [showClear]="true"
        [options]="(rabbits$ | async)!" optionLabel="name">
        <ng-template let-rabbit #item>
            <div class="flex items-center gap-2">
                @if (rabbit.isDisabled) {
                  <ng-icon name="gameSightDisabled" />
                }
                <div>{{ rabbit.name }}</div>
            </div>
          </ng-template>
          <ng-template let-rabbit #selectedItem>
            <div class="flex items-center gap-2">
                @if (rabbit.isDisabled) {
                  <ng-icon name="gameSightDisabled" />
                }
                <div>{{ rabbit.name }}</div>
            </div>
          </ng-template>
      </p-select>
    </div>
    <div>
      <p-button label="Erstellen" routerLink="/weight-entries/create">
        <ng-icon name="matAddSharp"></ng-icon>
      </p-button>
    </div>
  </div>
  <div class="rounded-border overflow-hidden">
    @if (filteredWeightEntries$ | async; as weightEntries) {
      <p-dataView [value]="weightEntries"
                  [paginator]="true"
                  [rows]="rowsPerPageDefaultOption"
                  [rowsPerPageOptions]="rowsPerPageOptions"
                  [pageLinks]="0"
                  [showCurrentPageReport]="true"
                  [currentPageReportTemplate]="currentPageReportTemplate"
                  layout="list">
        <ng-template #list let-entries>
          <div class="flex flex-col gap-2">
            @for (weightEntry of entries; track weightEntry.id) {
              <app-weight-entry-card [weightEntry]="weightEntry"
                (entryDeleted)="onEntryDeleted($event)"></app-weight-entry-card>
            }
          </div>
        </ng-template>
      </p-dataView>
    } @else {
    <div class="flex flex-col gap-2">
      @for (_ of skeletonsIterationSource; track $index) {
      <p-skeleton height="4rem" styleClass="mb-2" />
      }
    </div>
    }
  </div>
</section>
